import React from 'react';
import Counter from '../ReusableComponents/counter';


//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

//Images
import im1 from '../../assets/images/SDG/1.jpg';
import im2 from '../../assets/images/SDG/2.jpg';
import im3 from '../../assets/images/SDG/3.jpg';
import im4 from '../../assets/images/SDG/4.jpg';
import im5 from '../../assets/images/SDG/5.jpg';
import im6 from '../../assets/images/SDG/6.jpg';
import im8 from '../../assets/images/SDG/8.jpg';
import im11 from '../../assets/images/SDG/11.jpg';
import im13 from '../../assets/images/SDG/13.jpg';
import im14 from '../../assets/images/SDG/14.jpg';
import im15 from '../../assets/images/SDG/15.jpg';
import im16 from '../../assets/images/SDG/16.jpg';
import im17 from '../../assets/images/SDG/17.jpg';
import bg from '../../assets/images/background.svg'
import P8 from '../../assets/images/cardImages/nanhiKali.jpg';
import P8_small from '../../assets/images/cardImages/mobile/nanhiKali.jpg';
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import Woman2RoundedIcon from '@mui/icons-material/Woman2Rounded';
import BadgeIcon from '@mui/icons-material/Badge';

//chart js
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));


const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(1.8);
  }
  `}
`;

const counterData = [
    {
        "num": 88,
        "label": "Input material sourced from within India ",
        "icon": LocalShippingRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 23.4,
        "label": "Job Creation in Semi-Urban Locations",
        "icon": BadgeIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
    {
        "num": 40149,
        "label": "No. of Girls empowered under 'Project Nanhi Kali'",
        "icon": Woman2RoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 2,
        "label": "Beneficiaries from CSR Projects",
        "icon": GroupAddRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "Lakhs+"
    },
    {
        "num": 0,
        "label": "Projects requiring Rehabilitation and Resettlement",
        "icon": HomeWorkIcon,
        "prefix": "0",
        "isdecimal": false,
        "suffix": ""
    }
]

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

ChartJS.register(ArcElement, Tooltip, Legend);

//-----------------------------------------------

export const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Job creation in smaller towns',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0 && context.dataset.data[key] > 0.5) {
                    return context.dataset.data[key].toLocaleString('en-In') + "%";
                }

            },
            padding: -7,
            color: "white",
            font: {
                family: 'Georama',
                size: 12,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            stacked: true,
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,
            stacked: true,
            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels1 = ['FY23', 'FY24', 'FY25'];

export const data1 = {
    labels1,
    datasets: [
        {
            label: 'Metropolitan',
            data: {
                "FY23": 70.53,
                "FY24": 69.91,
                "FY25": 67.60
            },
            backgroundColor: '#4d4d4f',
            barThickness: 60
        },
        {
            label: 'Urban',
            data: {
                "FY23": 8.76,
                "FY24": 8.48,
                "FY25": 8.50
            },
            backgroundColor: '#747474',
            barThickness: 60
        },
        {
            label: 'Semi-urban',
            data: {
                "FY23": 20.27,
                "FY24": 21.14,
                "FY25": 23.40
            },
            backgroundColor: '#e31837',
            barThickness: 60
        },
        {
            label: 'Rural',
            data: {
                "FY23": 0.44,
                "FY24": 0.47,
                "FY25": 0.50
            },
            backgroundColor: '#000000',
            barThickness: 60
        },

    ],
};

const Sectionc8 = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };

    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expanded5g, setExpanded5g] = React.useState(false);
    const handleExpandClick5g = () => {
        setExpanded5g(!expanded5g);
    };

    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };

    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };

    const [expanded8, setExpanded8] = React.useState(false);
    const handleExpandClick8 = () => {
        setExpanded8(!expanded8);
    };

    const [expanded9, setExpanded9] = React.useState(false);
    const handleExpandClick9 = () => {
        setExpanded9(!expanded9);
    };

    const [expanded10, setExpanded10] = React.useState(false);
    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    };

    const [expanded11, setExpanded11] = React.useState(false);
    const handleExpandClick11 = () => {
        setExpanded11(!expanded11);
    };

    const [expanded12, setExpanded12] = React.useState(false);
    const handleExpandClick12 = () => {
        setExpanded12(!expanded12);
    };

    const [expanded13, setExpanded13] = React.useState(false);
    const handleExpandClick13 = () => {
        setExpanded13(!expanded13);
    };


    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true); setExpanded1(true); setExpanded2(true); setExpanded3(true); setExpanded4(true); setExpanded5(true); setExpanded5g(true); setExpanded6(true); setExpanded7(true); setExpanded8(true); setExpanded9(true); setExpanded10(true); setExpanded11(true); setExpanded12(true); setExpanded13(true);
    };
    const closeAll = () => {
        setExpand(false); setExpanded1(false); setExpanded2(false); setExpanded3(false); setExpanded4(false); setExpanded5(false); setExpanded5g(false); setExpanded6(false); setExpanded7(false); setExpanded8(false); setExpanded9(false); setExpanded10(false); setExpanded11(false); setExpanded12(false); setExpanded13(false);
    };

    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc7'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc9'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 8
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Inclusive Growth
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should promote inclusive growth and equitable development
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im1} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im2} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im3} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im4} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im5} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im6} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im8} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im11} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im13} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im14} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im15} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im16} height="40" alt="svg" /> </StyledBox>
                        <StyledBox><img src={im17} height="40" alt="svg" /> </StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: { xs: `url(${P8_small})`, sm: `url(${P8})` },
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Details of Social Impact Assessment(s) of projects undertaken by the entity based on applicable laws, in the current financial year.
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" >
                            <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                    <TableCell align="center"><strong>Name and brief details of project</strong></TableCell>
                                    <TableCell align="center"><strong>SIA notification
                                        No.</strong></TableCell>
                                    <TableCell align="center"><strong>Date of
                                        notification</strong></TableCell>
                                    <TableCell align="center"><strong>Whether conducted by independent external
                                        agency (Yes/No)</strong></TableCell>
                                    <TableCell align="center"><strong>Results communicated in public domain
                                        (Yes / No)</strong></TableCell>
                                    <TableCell align="center"><strong>Relevant Web
                                        Link</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell colSpan={6} align="center">Not Applicable</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mb={5} mt={2}>
                        <Typography variant='body1'>
                            The Company did not start any greenfield project in the reporting year, and hence, no social impact assessments of projects undertaken by the entity were required to be conducted as per applicable laws.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Information on project(s) for which ongoing Rehabilitation and Resettlement (R&R) is being undertaken by your entity
                            <ExpandMore
                                expand={expanded2}
                                onClick={handleExpandClick2}
                                aria-expanded={expanded2}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Name of project for which R&R is ongoing</strong></TableCell>
                                        <TableCell align="center"><strong>State</strong></TableCell>
                                        <TableCell align="center"><strong>District</strong></TableCell>
                                        <TableCell align="center"><strong>No of Project Affected Families (PAFs)</strong></TableCell>
                                        <TableCell align="center"><strong>% of PAFs covered by RAR</strong></TableCell>
                                        <TableCell align="center"><strong>Amount Paid to PAFs in the FY (in INR)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell colSpan={6} align="center">Not Applicable</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body1'>
                                The Company did not start any greenfield project in the reporting year, and hence, no community group was rehabilitated and
                                resettled for any project. Therefore, the question is not applicable.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Describe the mechanisms to receive and redress grievances of the community.
                            <ExpandMore
                                expand={expanded3}
                                onClick={handleExpandClick3}
                                aria-expanded={expanded3}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company has established a formal grievance redressal mechanism at each of its plant locations to ensure timely and effective resolution of concerns raised by the local community. A grievance register is maintained at the plant entrance gates, where community members can directly record their grievances.
                            <br /><br />
                            Once a grievance is received, it is addressed in accordance with a defined escalation matrix, which typically includes the Plant Operations Head and the Human Resources Team, depending on the nature of the issue. The grievance is first assessed and resolved at the local plant level, ensuring quick and contextual redressal.
                            <br /><br />
                            In cases where resolution at the plant level is not feasible or requires further intervention, the grievance is escalated to higher management levels as required. This structured approach enables transparency, accountability, and responsiveness to the concerns of the community.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Percentage of input material (inputs to total inputs by value) sourced from suppliers:
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Directly sourced from MSMEs/ small producers
                                        </TableCell>
                                        <TableCell align="center">9.7%</TableCell>
                                        <TableCell align="center">12%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Directly from within India
                                        </TableCell>
                                        <TableCell align="center">90.4%</TableCell>
                                        <TableCell align="center">88%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Job creation in smaller towns - Disclose wages paid to persons employed (including employees or workers employed on a permanent or non-permanent/ on contract basis) in the following locations as % of total wage cost
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                            <ExpandMore
                                expand={expanded5g}
                                onClick={handleExpandClick5g}
                                aria-expanded={expanded5g}
                                aria-label="show more"
                            >
                                <AssessmentOutlinedIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="left"><strong>Location</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2025-26*</strong></TableCell>
                                        <TableCell align="center"><strong>FY 2024-25</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Rural</TableCell>
                                        <TableCell align="center">0.7%</TableCell>
                                        <TableCell align="center">0.5%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Semi-urban</TableCell>
                                        <TableCell align="center">14.8%</TableCell>
                                        <TableCell align="center">23.4%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Urban</TableCell>
                                        <TableCell align="center">9.7%</TableCell>
                                        <TableCell align="center">8.5%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Metropolitan</TableCell>
                                        <TableCell align="center">74.8%</TableCell>
                                        <TableCell align="center">67.6%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Typography variant='body2' mt={2} sx={{ fontStyle: 'italic' }}>
                            (Location categorized as per RBI Classification System – rural/ semi-urban/ urban/ metropolitan)
                            <br></br>
                            *For the purpose of this disclosure, only wages paid to permanent employees and workers have been considered.
                        </Typography>
                    </Box>
                </Collapse>
                <Collapse in={expanded5g} timeout="auto" unmountOnExit>
                    <Box sx={{ mx: 'auto', width: { md: '100%', lg: '60%' } }} mt={4} mb={4}>
                        <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                            <Box>
                                <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    Job Creation in Smaller Towns
                                </Typography>
                            </Box>
                            <Box mt={1}>
                                <Typography variant='body2' sx={{ color: 'white' }}>
                                </Typography>
                            </Box>
                        </Box>
                        <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                            <Bar options={options1} data={data1} />
                        </Box>

                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Provide details of actions taken to mitigate any negative social impacts identified in the Social Impact Assessments (Reference: Question 1 of Essential Indicators above):
                            <ExpandMore
                                expand={expanded6}
                                onClick={handleExpandClick6}
                                aria-expanded={expanded6}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded6} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Details of negative social impact identified</strong></TableCell>
                                        <TableCell align="center"><strong>Corrective action taken</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row" colSpan={2}>Not Applicable</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body1'>
                                The Company did not start any greenfield project in the reporting year, and hence, no social impact assessments of projects undertaken by the entity were
                                required to be conducted as per applicable laws.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Provide the following information on CSR projects undertaken by your entity in designated aspirational districts as identified by government bodies:
                            <ExpandMore
                                expand={expanded7}
                                onClick={handleExpandClick7}
                                aria-expanded={expanded7}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded7} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>S. No.</strong></TableCell>
                                        <TableCell sx={{ width: 150 }}><strong>State</strong></TableCell>
                                        <TableCell><strong>Aspirational Districts</strong></TableCell>
                                        <TableCell align="center"><strong>Amount spent (In INR)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">1</TableCell>
                                        <TableCell>Andhra Pradesh</TableCell>
                                        <TableCell>Visakhapatnam, Vizianagaram, Y.S.R Kadapa</TableCell>
                                        <TableCell align="center">3,34,61,446.55</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">2</TableCell>
                                        <TableCell>Assam</TableCell>
                                        <TableCell>Barpeta, Dhubri, Goalpara</TableCell>
                                        <TableCell align="center">6,99,153.76</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">3</TableCell>
                                        <TableCell>Bihar</TableCell>
                                        <TableCell>Araria, Aurangabad, Banka, Begusarai, Gaya, Jamui, Katihar, Khagaria, Muzaffarpur, Nawada, Purnia, Sheikhpura, Sitamarhi</TableCell>
                                        <TableCell align="center">50,97,006.55</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">4</TableCell>
                                        <TableCell>Chhattisgarh</TableCell>
                                        <TableCell>Dantewada, Kanker, Kondagaon, Korba, Mahasamund, Narayanpur, Rajnandgaon</TableCell>
                                        <TableCell align="center">2,89,303.64</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">5</TableCell>
                                        <TableCell>Gujarat</TableCell>
                                        <TableCell>Dahod, Narmada</TableCell>
                                        <TableCell align="center">8,95,303.91</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">6</TableCell>
                                        <TableCell>Haryana</TableCell>
                                        <TableCell>Nuh (Mewat)</TableCell>
                                        <TableCell align="center">11,214.95</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">7</TableCell>
                                        <TableCell>Himachal Pradesh</TableCell>
                                        <TableCell>Chamba</TableCell>
                                        <TableCell align="center">99,480.00</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">8</TableCell>
                                        <TableCell>Jammu And Kashmir</TableCell>
                                        <TableCell>Baramulla, Kupwara</TableCell>
                                        <TableCell align="center">2,25,428.75</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">9</TableCell>
                                        <TableCell>Jharkhand</TableCell>
                                        <TableCell>Bokaro, Dumka, East Singhbhum, Garhwa, Giridih, Gumla, Hazaribagh, Khunti, Latehar, Palamu, Ramgarh, Ranchi, Sahibganj, West Singhbhum</TableCell>
                                        <TableCell align="center">1,37,89,076.73</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">10</TableCell>
                                        <TableCell>Karnataka</TableCell>
                                        <TableCell>Raichur</TableCell>
                                        <TableCell align="center">1,09,57,144.29</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">11</TableCell>
                                        <TableCell>Kerala</TableCell>
                                        <TableCell>Wayanad</TableCell>
                                        <TableCell align="center">3,51,907.06</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">12</TableCell>
                                        <TableCell>Madhya Pradesh</TableCell>
                                        <TableCell>Barwani, Chhatarpur, Damoh, Guna, Khandwa, Rajgarh, Vidisha</TableCell>
                                        <TableCell align="center">10,79,659.01</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">13</TableCell>
                                        <TableCell>Maharashtra</TableCell>
                                        <TableCell>Gadchiroli, Nandurbar, Dharashiv, Washim</TableCell>
                                        <TableCell align="center">7,64,716.10</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">14</TableCell>
                                        <TableCell>Odisha</TableCell>
                                        <TableCell>Balangir, Dhenkanal, Gajapati, Kalahandi, Kandhamal, Koraput, Malkangiri, Rayagada</TableCell>
                                        <TableCell align="center">26,81,065.68</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">15</TableCell>
                                        <TableCell>Punjab</TableCell>
                                        <TableCell>Firozpur, Moga</TableCell>
                                        <TableCell align="center">1,71,53,696.00</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">16</TableCell>
                                        <TableCell>Rajasthan</TableCell>
                                        <TableCell>Baran, Dholpur, Karauli, Sirohi</TableCell>
                                        <TableCell align="center">3,78,226.21</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">17</TableCell>
                                        <TableCell>Tamil Nadu</TableCell>
                                        <TableCell>Ramanathapuram, Virudhunagar</TableCell>
                                        <TableCell align="center">5,39,95,030</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">18</TableCell>
                                        <TableCell>Telangana</TableCell>
                                        <TableCell>Bhadradri Kothagudem</TableCell>
                                        <TableCell align="center">6,65,838.00</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">19</TableCell>
                                        <TableCell>Uttar Pradesh</TableCell>
                                        <TableCell>Bahraich, Balrampur, Chandauli, Chitrakoot, Fatehpur, Shrawasti, Siddharth Nagar, Sonbhadra</TableCell>
                                        <TableCell align="center">17,52,41,180.38</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center" component="th" scope="row">20</TableCell>
                                        <TableCell>Uttarakhand</TableCell>
                                        <TableCell>Haridwar, Udham Singh Nagar</TableCell>
                                        <TableCell align="center">1,36,16,078.88</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>

            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. a. Do you have a preferential procurement policy where you give preference to purchase from suppliers comprising marginalized /vulnerable groups?
                            <ExpandMore
                                expand={expanded8}
                                onClick={handleExpandClick8}
                                aria-expanded={expanded8}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded8} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            NA
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. b. From which marginalized/ vulnerable groups do you procure?
                            <ExpandMore
                                expand={expanded9}
                                onClick={handleExpandClick9}
                                aria-expanded={expanded9}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded9} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            NA
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. c. What percentage of total procurement (by value) does it constitute?
                            <ExpandMore
                                expand={expanded10}
                                onClick={handleExpandClick10}
                                aria-expanded={expanded10}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded10} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            NA
                        </Typography>
                    </Box>
                </Collapse>
            </Box>

            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Details of the benefits derived and shared from the intellectual properties owned or acquired by your entity (in the current financial year), based on traditional knowledge
                            <ExpandMore
                                expand={expanded11}
                                onClick={handleExpandClick11}
                                aria-expanded={expanded11}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded11} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Intellectual Property based on traditional knowledge</strong></TableCell>
                                        <TableCell align="center"><strong>Owned/ Acquired (Yes/ No)</strong></TableCell>
                                        <TableCell align="center"><strong>Benefit shared (Yes/ No)</strong></TableCell>
                                        <TableCell align="center"><strong>Basis of calculating of benefits shared</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell colSpan={4} align="center">Not Applicable</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body1'>
                                Not Applicable since the Company does not own and has not acquired any intellectual property based on traditional knowledge.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Details of corrective actions taken or underway, based on any adverse order in intellectual property related disputes wherein usage of traditional knowledge is involved.
                            <ExpandMore
                                expand={expanded12}
                                onClick={handleExpandClick12}
                                aria-expanded={expanded12}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded12} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>Name of authority</strong></TableCell>
                                        <TableCell align="center"><strong>Brief of case</strong></TableCell>
                                        <TableCell align="center"><strong>Corrective action taken</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell colSpan={3} align="center">Not Applicable</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mb={5} mt={2}>
                            <Typography variant='body1'>
                                Not Applicable since the Company does not own and has not acquired any intellectual property based on traditional knowledge.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            6. Details of beneficiaries of CSR Projects
                            <ExpandMore
                                expand={expanded13}
                                onClick={handleExpandClick13}
                                aria-expanded={expanded13}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded13} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="left"><strong>CSR Project*^</strong></TableCell>
                                        <TableCell align="center"><strong>No. of persons benefitted from CSR Projects</strong></TableCell>
                                        <TableCell align="center"><strong>% of beneficiaries from vulnerable and marginalized groups</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Women Empowerment</TableCell>
                                        <TableCell align="center">3,07,499</TableCell>
                                        <TableCell align="center">71%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Water Management</TableCell>
                                        <TableCell align="center">41,244</TableCell>
                                        <TableCell align="center">73%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Promotion of Education &amp; Scholarship</TableCell>
                                        <TableCell align="center">18,652</TableCell>
                                        <TableCell align="center">55%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Integrated Development</TableCell>
                                        <TableCell align="center">14,878</TableCell>
                                        <TableCell align="center">62%</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Skill development</TableCell>
                                        <TableCell align="center">11,746</TableCell>
                                        <TableCell align="center">67%</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mt={2}>
                            <Typography variant='body2'>
                                * The company’s CSR initiatives focus on empowering girls through education, enabling women through skill development, strengthening maternal and newborn healthcare, and promoting environmental conservation. Flagship programs include Project Nanhi Kali, supporting holistic development of girls from Grades 6–10; Kaabil, which enhances women’s economic participation through employability, domain, and agri-skilling; and Jal Samriddhi, which advances community-led water conservation and climate-resilient water management. These initiatives are aligned with the UN SDGs, national CSR guidelines, and the company’s ESG commitments.
                                <br />
                                ^ CSR Projects have been consolidated into Themes
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionc8;